import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface KeyValuesState {
    [key: string]: string
}

const initialState: KeyValuesState = {}

export const keyValuesSlice = createSlice({
    name: 'keyValues',
    initialState,
    reducers: {
        setKeyValue(state, action: PayloadAction<{ key: string; value: string | undefined }>) {
            const { key, value } = action.payload
            if (value === undefined) {
                delete state[key]
            } else {
                state[key] = value
            }
        },
    },
})

export const { setKeyValue } = keyValuesSlice.actions
